export const ControlPanelEditionProfiles = [
  {
    identifier: 'customField',
    linkTo: '/customField',
    profiles: '0,50'
  }
  /*,
  {
  identifier: 'companyAdmin',
  linkTo: '/companyAdmin',
  profiles: '0,5,50'
  }
  */
];

export const ControlPanelProfiles = [
  {
    identifier: 'INFRAESTRUCTURA',
    type: 'GROUP',
    text: 'Infraestructura'
  },
  {
    identifier: 'PARAMETRIZACION',
    type: 'GROUP',
    title: 'Parametrización'
  },
  {
    identifier: 'MANTENIMIENTO',
    type: 'GROUP',
    title: 'Mantenimiento'
  },
  {
    identifier: 'logs',
    type: 'OPTION',
    text: 'ControlPanel.logs.title',
    icon: 'fa fa-file-text-o',
    linkTo: '/logs',
    linkParams: '',
    profiles: '0,50',
    group: 'INFRAESTRUCTURA'
  },
  {
    identifier: 'monitorization',
    type: 'OPTION',
    text: 'ControlPanel.monitoring.title',
    icon: 'fa fa-area-chart',
    linkTo: '/monitorization',
    linkParams: '',
    profiles: '0,50',
    group: 'INFRAESTRUCTURA'
  },
  {
    identifier: 'eventAudit',
    type: 'OPTION',
    text: 'ControlPanel.audit.title',
    icon: 'fa fa-arrows-h',
    linkTo: '/eventAudit',
    profiles: '0,50',
    group: 'INFRAESTRUCTURA'
  },
  {
    identifier: 'license',
    type: 'OPTION',
    text: 'ControlPanel.licenses.title',
    icon: 'far fa-registered',
    linkTo: '/license',
    linkParams: '',
    profiles: '0,50',
    group: 'INFRAESTRUCTURA'
  },
  {
    identifier: 'actions',
    type: 'OPTION',
    text: 'ControlPanel.actions.title',
    icon: 'fa fa-share-square',
    linkTo: '/actions',
    linkParams: '',
    profiles: '0,50',
    group: 'INFRAESTRUCTURA'
  },
  {
    identifier: 'timers',
    type: 'OPTION',
    text: 'Servicios',
    icon: 'fa fa-server',
    linkTo: '/timers',
    linkParams: '',
    profiles: '0,50',
    group: 'INFRAESTRUCTURA'
  },
  {
    identifier: 'actions_CLEAR_CACHE',
    type: 'OPTION',
    text: 'ControlPanel.actions.caches.title',
    icon: 'fa fa-eraser',
    linkTo: '/actions',
    profiles: '0,50',
    linkParams: 'CLEAR_CACHE',
    group: 'INFRAESTRUCTURA'
  },
  {
    identifier: 'sessions',
    type: 'OPTION',
    text: 'ControlPanel.sessions.title',
    icon: 'fa fa-plug',
    linkTo: '/sessions',
    linkParams: '',
    profiles: '0,50',
    group: 'INFRAESTRUCTURA'
  },
  {
    identifier: 'eventViewer',
    type: 'OPTION',
    text: 'ControlPanel.eventViewer.title',
    icon: 'fa-solid fa-eye',
    linkTo: '/AudMessage',
    linkParams: '',
    profiles: '0,50',
    group: 'INFRAESTRUCTURA'
  },
  {
    identifier: 'validations',
    type: 'OPTION',
    text: 'ControlPanel.valitations.title',
    icon: 'fa fa-check-square-o ',
    linkTo: '/validations',
    profiles: '0,50',
    group: 'PARAMETRIZACION'
  },
  {
    identifier: 'helpAdmin',
    type: 'OPTION',
    text: 'ControlPanel.help.title',
    icon: 'fa fa-question ',
    linkTo: '/helpAdmin',
    linkParams: '',
    profiles: '0,50',
    group: 'PARAMETRIZACION'
  },
  {
    identifier: 'customFields',
    type: 'OPTION',
    text: 'ControlPanel.customFields.title',
    icon: 'fas fa-file-invoice ',
    linkTo: '/customFields',
    linkParams: '',
    profiles: '0,50',
    group: 'PARAMETRIZACION'
  },
  {
    identifier: 'actions_LOAD_USER',
    type: 'OPTION',
    text: 'ControlPanel.actions.usersload.title',
    icon: 'fa fa-users',
    linkTo: '/actions',
    linkParams: 'LOAD_USER',
    profiles: '0,50',
    group: 'MANTENIMIENTO',
  },
  {
    identifier: 'companyList',
    type: 'OPTION',
    text: 'ControlPanel.company.title',
    icon: 'far fa-credit-card',
    linkTo: '/companyList',
    profiles: '0,5,50,201,202',
    group: 'MANTENIMIENTO',
  },
  {
    identifier: 'dossierModels',
    type: 'OPTION',
    text: 'ControlPanel.models.title',
    icon: 'far fa-clipboard',
    linkTo: '/dossierModels',
    profiles: '0,50',
    group: 'MANTENIMIENTO',
  },
  {
    identifier: 'formulas',
    type: 'OPTION',
    text: 'ControlPanel.formulas.title',
    icon: 'fas fa-calculator',
    linkTo: '/formulas',
    profiles: '0,50',
    group: 'MANTENIMIENTO',
  },
  {
    identifier: 'criteriaDefList',
    type: 'OPTION',
    text: 'ControlPanel.criteriaDefList.title',
    icon: 'fas fa-gavel',
    linkTo: '/criteriaDefList',
    profiles: '0,50',
    group: 'MANTENIMIENTO',
  },
  {
    identifier: 'substitutions',
    type: 'OPTION',
    text: 'ControlPanel.substitutions.title',
    icon: 'fas fa-people-carry',
    linkTo: '/substitutions',
    profiles: '0,50',
    group: 'MANTENIMIENTO',
  },
  {
    identifier: 'resourceFiles',
    type: 'OPTION',
    text: 'ControlPanel.resourceFilesList.title',
    icon: 'fas fa-cogs ',
    linkTo: '/resourceFiles',
    profiles: '0,50',
    linkParams: '',
    group: 'MANTENIMIENTO'
  },
  {
    identifier: 'exportProcess',
    type: 'OPTION',
    text: 'ControlPanel.exportProcesses.title',
    icon: 'fa fa-cloud-download ',
    linkTo: '/exportProcesses',
    profiles: '0,5',
    _linkParams: '',
    group: 'MANTENIMIENTO'
  },
  {
    identifier: 'inboxs',
    type: 'OPTION',
    text: 'ControlPanel.inboxs.title',
    icon: 'fas fa-inbox ',
    linkTo: '/inbox',
    profiles: '0,50',
    group: 'MANTENIMIENTO'
  },
  {
    identifier: 'users',
    type: 'OPTION',
    text: 'ControlPanel.users.title',
    icon: 'fas fa-user ',
    linkTo: '/users',
    profiles: '0,50',
    group: 'MANTENIMIENTO'
  },
  {
    identifier: 'organizationalunits',
    type: 'OPTION',
    text: 'ControlPanel.organizationalunits.title',
    icon: 'fas fa-sitemap',
    linkTo: '/organizationalunits',
    profiles: '0,50',
    group: 'MANTENIMIENTO'
  },
  {
    identifier: 'signatureTool',
    type: 'OPTION',
    text: 'ControlPanel.signatureTool.title',
    icon: 'fas fa-pen-nib',
    linkTo: '/signatureTool',
    profiles: '0,50',
    group: 'MANTENIMIENTO'
  }
];